import React, { useState } from "react";
import { useHistory } from "react-router-dom";



const Context = React.createContext();

const TestFunction = ({ children }) => {
    const [pregunta, setPregunta] = useState(1);
    const [puntaje, setPuntaje] = useState(0);
    const history = useHistory();


    const onAddPuntaje = (valor, preguntaActual) => {
        console.log("marcada ", preguntaActual);
        
        setTimeout(() => {
            onChangePregunta(valor,preguntaActual);
        }, 500);
    }

    const onChangePregunta = (valor,preguntaActual) => {

        console.log("previa validacion ", preguntaActual);
        setPregunta(preguntaActual);
        (pregunta === 5) ? history.push(`/resultado`) :
            (pregunta === 6) ? history.push(`/concurso`) :
                history.push(`/preguntas/${preguntaActual}`);
                setPuntaje((puntaje + valor));
    }

    const onResetPuntaje = () => {
        setPuntaje(0);
        setPregunta(1);
        history.push(`/preguntas/${1}`);
    }

    return <Context.Provider value={{ pregunta, puntaje, onAddPuntaje, onChangePregunta, onResetPuntaje }}>
        {children}
    </Context.Provider>

}

export { TestFunction, Context }